export default "__VITE_ASSET__6b3b20b4__"